export const addSocial = (list, selector) => {
  const socialList = document.querySelector(selector);

  if (socialList)
    socialList.appendChild(list)
}